import { Box, FlexBox, Typography, Link, Button } from '@vp/swan';
import React, { useContext, useEffect } from 'react';
import './src-components-PrivacyCookiePolicy-PrivacyCookiePolicy.styles.scss.js';
import { useCustomTracking } from './src-hooks-custom-hooks-useTracking.js';
import { getPrivacyPolicyLink } from './src-config-privacy-link.js';
import { CAContext } from './src-contexts-CAContext.js';

const PrivacyCookiePolicy = ({ onPrivacyCookiePolicyAccept }) => {
  const { sendTrackingEvent } = useCustomTracking();
  const {
    chatState: { locale, chatWindow }
  } = useContext(CAContext);
  useEffect(() => {
    if (chatWindow === "maximized") {
      sendTrackingEvent("Chatbot Viewed", "Chatbot:Privacy", "chatPrivacyShown");
    }
  }, [chatWindow]);
  return /* @__PURE__ */ React.createElement(Box, { className: "outerContainer", compactMode: true }, /* @__PURE__ */ React.createElement(FlexBox, { flexDirection: "row", gap: "5", className: "innerContainer", compactMode: true }, /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-small", textColor: "subtle", style: { flexGrow: 1 } }, "By clicking 'Agree', you consent to VistaPrint and its chat service provider recording and using chat communications as described in the", " ", /* @__PURE__ */ React.createElement(Link, { className: "policyLink", target: "_blank", href: getPrivacyPolicyLink(locale), rel: "noreferrer" }, "Privacy and Cookie Policy"), "."), /* @__PURE__ */ React.createElement(Button, { className: "agreeButton", onClick: onPrivacyCookiePolicyAccept, skin: "secondary", style: { minWidth: "72px", maxHeight: "48px" } }, "Agree")));
};

export { PrivacyCookiePolicy as default };
//# sourceMappingURL=src-components-PrivacyCookiePolicy-PrivacyCookiePolicy.js.map
